import { type FC } from 'react'
import { PrepQuestionsCard } from './PrepQuestionsCard'
import { PrepQuestionsSkeleton } from './PrepQuestionsSkeleton'
import { LIKELY_QUESTIONS_LIMIT, LIKELY_QUESTIONS_WINDOW } from './prepQuestionsConfig'
import { useGetLikelyQuestionsQuery } from '../../../../../../store/questionInsights/questionInsights'
import { useAppSelector } from '../../../../../../store/hooks'
import { selectAccountId } from '../../../../../../store/auth/authSlice'

export const PrepQuestions: FC = () => {
  const accountId = useAppSelector(selectAccountId)
  const {
    data: questions,
    isLoading,
    isFetching,
    isError,
  } = useGetLikelyQuestionsQuery(
    { accountId, window: LIKELY_QUESTIONS_WINDOW, limit: LIKELY_QUESTIONS_LIMIT },
    { skip: !accountId, refetchOnMountOrArgChange: true },
  )

  if (!accountId) {
    return null
  }

  if (isLoading || isFetching) {
    return <PrepQuestionsSkeleton />
  }

  if (isError) {
    return null
  }

  return <PrepQuestionsCard questions={questions ?? []} />
}
